/**
 * @fileoverview The refusal codes and statuses `server/api/v1/paths/oauth2/callback.js` sends.
 * Only these codes reach `/auth-error`; every other failure uses `signin_failed`.
 */

/** The code for every failed sign-in that is not one of the refusals below. */
const SIGN_IN_FAILED = 'signin_failed';

/** Each refusal code with the only HTTP status the callback sends it with. */
const SIGN_IN_REFUSAL_STATUSES = Object.freeze({
  identity_conflict: 409,
  email_unverified: 409,
  account_unavailable: 409,
  email_required: 422,
  nonce_mismatch: 401,
  unsupported_issuer: 401,
});

/**
 * Returns the refusal code a failed callback response carries, if it is one `/auth-error` explains.
 *
 * @param {*} status - The response's HTTP status.
 * @param {*} code - The response body's `code`.
 * @returns {string|undefined} The code when it is a known refusal sent with its own status.
 */
function signInRefusalCode(status, code) {
  return typeof code === 'string'
    && Object.prototype.hasOwnProperty.call(SIGN_IN_REFUSAL_STATUSES, code)
    && SIGN_IN_REFUSAL_STATUSES[code] === status
    ? code
    : undefined;
}

export { SIGN_IN_FAILED, SIGN_IN_REFUSAL_STATUSES, signInRefusalCode };
